import _axios from 'axios'

import axios from '../../function/axiosInstance'
import extract from '../../function/extract'
import { USER_SERVICE_BASE_URL } from '../config'

export const getPendingInvites = async (): Promise<{
  status: 'error' | 'ok'
  data: null | { records: InviteRecord[]; status: 'success' }
  error: string | undefined
}> => {
  try {
    const response = await axios.get('/pending-invites')
    return extract.data(response)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}

export const joinPendingInvites = async ({
  inviteId
}: {
  inviteId: string
}): Promise<{
  status: 'error' | 'ok'
  data: null
  error: string | undefined
}> => {
  try {
    const response = await _axios.post(
      `${USER_SERVICE_BASE_URL}/companies/join`,
      { invite_code: inviteId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

interface GetInvitesArgs {
  inviteId: string
  inviteHash: string
}

type GetInvitesReturnType = Promise<{
  status: 'error' | 'ok'
  data: null | {
    email: string
    first_name: string
    last_name: string
    role: string
  }
  error?: string
}>

export const getInvites = async ({
  inviteId,
  inviteHash
}: GetInvitesArgs): GetInvitesReturnType => {
  try {
    const response = await _axios.get(
      `${USER_SERVICE_BASE_URL}/users/invites/${inviteId}`,
      {
        params: { invite_hash: inviteHash }
      }
    )
    return extract.data(response)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}
